import $fetch from '@/services/client'
import { $country } from '@/stores/Country'
import { $language } from '@/stores/Language'

async function listCountries() {
  const response = await $fetch('list-countries/mycontroller/json', {
    body: {
      lang: $language.get(),
    },
    // cache: 'force-cache',
  })
  if (response.error) throw new Error(response.error.statusText + response.error.message)

  // Only preselect country by IP if no country has been selected yet
  const currentCountry = $country.get()
  if (!currentCountry) {
    const preselectedCountry = response.data.data.find(country => country.preselection_by_ip === true)
    if (preselectedCountry) {
      $country.set(preselectedCountry.isocode2)
    }
  }

  return response.data.data
}

export default listCountries
